import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav, Icon } from 'rsuite';

const NavToggle = ({ expand, onChange }) => (
  <Navbar appearance="subtle" className="nav-toggle">
    <Navbar.Body>
      <Nav pullRight>
        <Nav.Item onClick={onChange} style={{ width: 56, textAlign: 'center' }}>
          <Icon icon={expand ? 'angle-left' : 'angle-right'} />
        </Nav.Item>
      </Nav>
    </Navbar.Body>
  </Navbar>
);

NavToggle.propTypes = {
  expand: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default NavToggle;
